export default __webpack_public_path__ + "static/media/dp-react.49425864.png";